import { client } from "../../utilities/config";
import { CREATE_CUSTOM_ORDER } from '../../../graphql/customOrder';

export const createCustomOrder = async (orderData) => {
    const response = await client.mutate({
      mutation: CREATE_CUSTOM_ORDER,
      variables: orderData
    });
    return response;
};
